import React, { useEffect, useState } from 'react';
import ls from 'local-storage';
import {
  CButton,
  CCard,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CCol
} from '@coreui/react';
import Moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { format, isWeekend } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { dailyRecap, reportPerDay } from 'src/services/Transactions';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { useWindowDimensions } from 'src/reusables/useWindowDimension';
import BoothPicker from 'src/components/BoothPicker';
import DataTable from 'src/components/DataTable';

function DailyRecap() {
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [renderCounter, setRenderCounter] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);
  const startDay = Moment(new Date('Jan 1 2023')).format('YYYY-MM-DD');

  const [trxRows, setTrxRows] = useState([]);
  const [trxColumns, setTrxColumns] = useState([]);

  const navigate = useNavigate();
  const { height, width, comparison } = useWindowDimensions();

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf('month')}`),
      endDate: new Date()
    }
  ]);

  async function fetchDailyRecap(dateFrom, dateTo, id) {
    const res = await dailyRecap(dateFrom, dateTo, id ?? '');

    const rows =
      res.data &&
      res.data.map((item, i) => {
        return {
          id: i,
          gross: formatter('currency', item?.gross ?? 0),
          discount: formatter('currency', item?.discount ?? 0),
          timeout: item.timeout,
          revenue: formatter('currency', item?.revenue ?? 0),
          prints: item.prints,
          reprints: item.reprints,
          grossReprints: formatter('currency', item?.gross_reprint ?? 0),
          date: formatter('longDate', item?.day ?? '0000-00-00'),
          happyHour: item.is_happy_hour
        };
      });

    setTrxRows(rows);

    const columns = [
      { field: 'date', headerName: 'Date', width: '200' },
      { field: 'prints', headerName: 'Trx Prints', width: '150' },
      { field: 'reprints', headerName: 'Reprints', width: '150' },
      { field: 'gross', headerName: 'Gross', width: '150' },
      { field: 'grossReprints', headerName: 'Gross Reprint', width: '150' },
      { field: 'discount', headerName: 'Discount', width: '150' },
      { field: 'revenue', headerName: 'Revenue', width: '150' },
      { field: 'timeout', headerName: 'Timeout', width: '150' },
      { field: 'happyHour', headerName: 'Happy Hour', width: '150' }
    ];

    setTrxColumns(columns);
    setTableLoading(false);
  }

  function toSQLDateFormat(date) {
    return Moment(new Date(date)).format('YYYY-MM-DD');
  }

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
  }

  useEffect(() => {
    setTableLoading(true);
    const newStartDay = formatter('SQLDate', dateRange[0].startDate);
    const newEndDay = formatter('SQLDate', dateRange[0].endDate);

    fetchDailyRecap(newStartDay, newEndDay, ls.get('booth')?.id ?? '');
    setRefetch(false);
    setRenderCounter(renderCounter + 1);
  }, [dateRange, refetch, drModal]);

  function handleRowClick(params) {
    navigate('/transaction-details', {
      state: params.row
    });
  }

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
    return (
      <div>
        <span
          style={{
            fontWeight: '600'
          }}
        >
          {format(day, 'd')}
        </span>
      </div>
    );
  }

  return (
    <div style={{ color: 'black' }}>
      <CRow>
        <CCol>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange[0].startDate).format('ll')}
              {' - '}
              {Moment(dateRange[0].endDate).format('ll')}
            </div>
          </CButton>
        </CCol>
        <CCol>
          <BoothPicker />
        </CCol>
      </CRow>

      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(!drModal)}>
            Close
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>

      <CHeader style={{ fontSize: '30px', marginTop: '3vh', padding: '1vh 2vw' }}>
        Daily Recap &emsp;{' '}
        <CButton onClick={(e) => navigate('/bulk-daily-recap')} style={{ backgroundColor: '#4E5B97', border: 'none' }}>
          Bulk Daily Recap
        </CButton>
      </CHeader>
      <CCard style={{ textAlign: 'center' }}>
        <DataTable rows={trxRows} columns={trxColumns} loading={tableLoading} style={{ textAlign: 'center' }} />
        {/* <DataGrid
          rows={trxRows}
          columns={trxColumns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[5, 10, 20, 25]}
          checkboxSelection
          style={{ textAlign: "center" }}
        /> */}
      </CCard>
    </div>
  );
}

export default DailyRecap;
